import FormRecord from "../../components/FormRecord/FormRecord";
import ListRecords from "../../components/ListRecords/ListRecords";
import DeletedRecords from "../../components/DeletedRecords/DeletedRecords";
import EditForm from "../../components/EditForm/EditForm";

import { useNavigate } from "react-router-dom";
import "./Home.css";

import { useState } from "react";

const logoACTotal: string =
  "https://cdn.actotal.com/assets/logos/ACTLogoDark.svg";

const Home = () => {
  const navigate = useNavigate();

  const [popUp, setPopUp] = useState<boolean>(false);
  const [editPopUp, setEditPopUp] = useState<boolean>(false);

  return (
    <div className="Home">
      <header className="Home-header">
        <img src={logoACTotal} className="Home-logo" alt="logo" />
      </header>
      <div className="Home-body">
        <div className="Home-box">
          Ingreso de datos
          <div className="Home-form-box">
            <FormRecord />
          </div>
        </div>
        <div className="Home-middle"></div>
        <div className="Home-box">
          Listado de datos
          <div className="Home-list-box">
            <ListRecords setEditPopUp={setEditPopUp} />
          </div>
        </div>
      </div>
      <div
        className="Recycle-Bin"
        style={popUp ? { display: "block" } : { display: "none" }}
      >
        <button onClick={() => setPopUp(false)}>X</button>
        <DeletedRecords />
      </div>
      <div
        className="Edit-Form"
        style={editPopUp ? { display: "block" } : { display: "none" }}
      >
        <button onClick={() => setEditPopUp(false)}>X</button>
        <EditForm />
      </div>
      <div className="Home-footer">
        <p className="Home-link" onClick={() => navigate("/")}>
          Go Back
        </p>
        <p className="Home-link" onClick={() => setPopUp(true)}>
          Recycle Bin
        </p>
      </div>
    </div>
  );
};

export default Home;
